//export let pvtkey: string = '';
//import { bsv } from "scrypt-ts";

import { bsv } from '../scrypt-ts-this/distthis/index'

//////////////////////////////////////////////////////////////////////////////////////////
// Jesus is the Lord
//////////////////////////////////////////////////////////////////////////////////////////

//https://witnessonchain.com/
//export async function oracleWoC(myURL: string): Promise <exchagePRICE[]>
//export async function oracleWoC(myURL: string): Promise <any>

export async function oracleWoC(myURL: string): Promise<any> {

  //console.log(`Message received in worker: ${event.data}`);
  //const url = new URL('https://www.example.com/path?query=value');
  //let poolID: number = 0; //default = WoC
  let npools: number = 1 // somente WoC por enquanto

  console.log('Até aqui: ', myURL)

  /////////////////////////////////////////////////
  //JESUS is the LORD!!!
  /////////////////////////////////////////////////

  let url: URL;


  let resp = '';

  let bcFinish = false
  let cycle = 0



  let result;
  while (!bcFinish && cycle < npools * 2) {

    //url = new URL('https://witnessonchain.com/v1/rates/BSV_USDC')
    url = new URL(myURL)


    console.log('URL', url)

    /*

    app.use('/', async (req, res) => {
      const response = await fetch('https://witnessonchain.com/v1/info', {
        headers: {
          'Access-Control-Allow-Origin': '*', // Replace '*' with specific origins for production
        },
      });
      const data = await response.json();
      res.json(data);

      console.log('res: ', res)
    });
    */


    try {

      console.log('URL', url)



      await fetch(url

        , {
          /*,  headers: {
              'Access-Control-Allow-Origin': 'http://localhost:3000', // Replace '*' with specific origins for production
            },*/
          method: 'GET',
          //mode: 'no-cors'
        }
      )
      try {
        const response = await fetch(url, {
          method: 'GET',
        });
        resp = await response.text();
        console.log('Success Data: ', resp);
      } catch (error) {
        resp = '';
      }




      console.log('Success: ', resp);

      //result = JSON.parse('['+ resp + ']');

      //console.log('Result Int: ', result)
      //console.log('Index Not Found: ', resp.indexOf('Not Found'))


      //{"rate":47.355999999999995,"time":1700413530,"currency":"USD"} 
      //if (resp.indexOf('[]') !== -1  || resp.indexOf('"time":') !== -1 || resp.indexOf('"height":') !== -1 ) {
      if (resp.indexOf('Not Found') === -1) {

        console.log('Success: ', resp);
        bcFinish = true

        result = JSON.parse('[' + resp + ']');

        console.log('Result Int: ', result)

      }

    } catch (e) {
      console.error(e);
    }

    cycle++;

  }

  if (bcFinish) {
    ///return resp
    //return exchangePrice
    return result
  }
  else {
    //return ''
    //return exchangePrice
    return result
  }
}

//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////
// Jesus is the Lord
//////////////////////////////////////////////////////////////////////////////////////////


//////////////////////////////////////////////////////////////////////////////////////////
// OBS: API atualizada 
//////////////////////////////////////////////////////////////////////////////////////////

export async function broadcast(tx: any, homenetwork: any): Promise<string> {
  //console.log(`Message received in worker: ${event.data}`);
  //const url = new URL('https://www.example.com/path?query=value');
  let poolID: number = 3; //default = 3 Bitails Big TX
  let npools: number = 4
  let TxHexBsv: string = tx;
  let urlAdress01: string = 'https://api.whatsonchain.com/v1/bsv/main/tx/raw';
  let urlAdress02: string = 'https://mapi.gorillapool.io/mapi/tx';
  let urlAdress03: string = 'https://api.bitails.io/tx/broadcast';
  let urlAdress04: string = 'https://api.bitails.io/tx/broadcast/multipart';
  let txID: string = new bsv.Transaction(tx).id;


  if (homenetwork === bsv.Networks.testnet) {
    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/main/tx/raw';
    urlAdress02 = 'https://testnet-mapi.gorillapool.io/mapi/tx'; // gorillapool is not in the tasks but let's leave it or fix it later
    urlAdress03 = 'https://api.bitails.io/tx/broadcast';
    urlAdress04 = 'https://api.bitails.io/tx/broadcast/multipart';
  }

  /////////////////////////////////////////////////
  //JESUS is the LORD!!!
  /////////////////////////////////////////////////

  let url: URL;

  console.log('pool id', poolID)

  let TXJson;

  let bcFinish = false
  let cycle = 0
  while (!bcFinish && cycle < npools * 2) {


    switch (poolID) {
      case 0: url = new URL(urlAdress01);
        TXJson = `{"txhex": "${TxHexBsv}" }`;
        break;
      case 1: url = new URL(urlAdress02);
        TXJson = `{"rawTx": "${TxHexBsv}" }`;
        break;
      case 2: url = new URL(urlAdress03);
        TXJson = `{"raw": "${TxHexBsv}" }`
        break;
      default: url = new URL(urlAdress04);
        TXJson = `{"raw": "${TxHexBsv}" }`
        break;
    }


    try {

      console.log('URL', url)

      let resp = '';
      if (poolID === 3) {
        //https://stackoverflow.com/questions/46640024/how-do-i-post-form-data-with-fetch-api
        const formData = new FormData();

        formData.append('raw', new Blob([Buffer.from(TxHexBsv, 'hex')]));
        formData.append('filename', 'raw');

        await fetch(url, {
          method: 'POST',
          //body: content,
          body: formData,
          //headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}             
        }).then(response => response.text())//then(response=>response.json())
          .then(data => {
            resp = data;
            //console.log(data); 
          });
      }
      else {
        await fetch(url, {
          method: 'POST',
          //body: content,
          body: TXJson,
          //headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'} 
          headers: {
            'Content-Type': 'application/json',
            'accept': 'text/plain'
          }

        }).then(response => response.text())//then(response=>response.json())
          .then(data => {
            resp = data;
            //console.log(data); 
          });
      }

      if (resp.indexOf(txID) !== -1) {

        //console.log('Success: ', resp);
        bcFinish = true
      } else {

        bcFinish = false
        console.log('Not Success: ', resp);
      }

    } catch (e) {
      console.error(e);
    }

    cycle++;
    poolID++;
    poolID = poolID % npools;

    console.log('Pool id: ', poolID)

  }

  if (bcFinish) {
    return txID
  }
  else {
    return ''
  }
}

interface UTXO {
  height: number;
  time: number;
  txId: string;
  outputIndex: number;
  satoshis: number;
  script: string;
}

//////////////////////////////////////////////////////////////////////////////////////////
// Jesus is the Lord
//////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////
// OBS: API planejada para ser descontinuada
// **************** Atualizar 
//////////////////////////////////////////////////////////////////////////////////////////

//export async function listUnspent(addOrScriptHash: any, homenetwork: any): Promise <string>
export async function listUnspent(addOrScriptHash: any, homenetwork: any): Promise<UTXO[]> {
  //console.log(`Message received in worker: ${event.data}`);
  //const url = new URL('https://www.example.com/path?query=value');
  let poolID: number = 0; //default = WoC
  let npools: number = 2


  if (poolID === 1000)//Não usar a nova API por enquanto.
  {
    let UTXOconf = await listUnspentConfWOC(addOrScriptHash, homenetwork)
    let UTXOunconf = await listUnspentUnconfWOC(addOrScriptHash, homenetwork)



    let utxos: UTXO[] = []

    for (let i = 0; i < UTXOconf.length; i++) {
      if (UTXOconf[i].outputIndex > -1) {
        utxos.push(UTXOconf[i])
      }
    }

    for (let i = 0; i < UTXOunconf.length; i++) {

      if (UTXOunconf[i].outputIndex > -1) {
        utxos.push(UTXOunconf[i])
      }

    }
    console.log('Conf UTXOs: ', UTXOconf)
    console.log('Unconf UTXOs: ', UTXOunconf)

    console.log('UTXOs: ', utxos)

    return utxos
  }

  //https://api.whatsonchain.com/v1/bsv/main/address/12XFn6p1H831shGhbd1UobrVqXFEpCBTPp/unspent
  //https://api.bitails.io/address/12XFn6p1H831shGhbd1UobrVqXFEpCBTPp/unspent

  let urlAdress01: string = 'https://api.whatsonchain.com/v1/bsv/main/address/';
  let urlAdress02: string = 'https://api.bitails.io/address/';

  if (addOrScriptHash.length === 64) {

    console.log('Hash Length: ', addOrScriptHash.length)
    //https://api.whatsonchain.com/v1/bsv/main/script/995ea8d0f752f41cdd99bb9d54cb004709e04c7dc4088bcbbbb9ea5c390a43c3/unspent
    //Returns a response as long as the response message is less than 1MB in size.

    //https://api.bitails.io/scripthash/408d9e88bf59190a2504b0d5e8075fd456c1fe6c593a58177f6df5200e61d118/unspent

    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/main/script/';
    urlAdress02 = 'https://api.bitails.io/scripthash/';
    //urlAdress03 = 'https://test-api.bitails.io/tx/broadcast';
    //urlAdress04 = 'https://test-api.bitails.io/tx/broadcast/multipart';
  }

  if (homenetwork === bsv.Networks.testnet) {
    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/test/address/';
    urlAdress02 = 'https://test-api.bitails.io/address/';

    if (addOrScriptHash.length === 64) {
      //https://api.whatsonchain.com/v1/bsv/test/script/995ea8d0f752f41cdd99bb9d54cb004709e04c7dc4088bcbbbb9ea5c390a43c3/unspent
      //Returns a response as long as the response message is less than 1MB in size.

      //https://test-api.bitails.io/scripthash/408d9e88bf59190a2504b0d5e8075fd456c1fe6c593a58177f6df5200e61d118/unspent

      urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/test/script/';
      urlAdress02 = 'https://test-api.bitails.io/scripthash/';
      //urlAdress03 = 'https://test-api.bitails.io/tx/broadcast';
      //urlAdress04 = 'https://test-api.bitails.io/tx/broadcast/multipart';
    }
  }

  /////////////////////////////////////////////////
  //JESUS is the LORD!!!
  /////////////////////////////////////////////////

  let url: URL;

  console.log('pool id', poolID)

  let resp = '';

  let bcFinish = false
  let cycle = 0

  let utxoScript = ''
  if (addOrScriptHash.length !== 64) {
    utxoScript = bsv.Script.buildPublicKeyHashOut(addOrScriptHash).toHex()
  }

  let utxos;
  while (!bcFinish && cycle < npools * 2) {
    switch (poolID) {
      case 0: url = new URL(urlAdress01 + addOrScriptHash + '/unspent');
        //TXJson = `{"txhex": "${TxHexBsv}" }`; 
        break;
      default: url = new URL(urlAdress02 + addOrScriptHash + '/unspent');
        //TXJson = `{"rawTx": "${TxHexBsv}" }`;
        break;
    }

    console.log('URL', url)

    try {

      console.log('URL', url)

      try {
        const response = await fetch(url);
        resp = await response.text();
      } catch (error) {
        resp = '';
      }

      if (resp.indexOf('[]') !== -1 || resp.indexOf('"time":') !== -1 || resp.indexOf('"height":') !== -1) {

        //console.log('Success: ', resp);
        bcFinish = true

        let res = JSON.parse(resp);

        if (resp.indexOf('[]') !== -1) {
          let res = JSON.parse('[{"height":-2,"tx_pos":-1,"tx_hash":"","value":0}]');
          utxos = res.map((item: any) => ({
            height: item.height,
            time: -2,
            txId: item.tx_hash,
            outputIndex: item.tx_pos,
            satoshis: item.value,
            script: utxoScript,
          }));

        }
        else if (poolID === 0) {
          //utxos = res.body.map((item: any) => ({
          utxos = res.map((item: any) => ({
            height: item.height,
            time: -1,
            txId: item.tx_hash,
            outputIndex: item.tx_pos,
            satoshis: item.value,
            script: utxoScript,
          }));
        }
        else {
          res = JSON.parse(resp.substring(resp.indexOf('['), resp.indexOf(']') + 1));
          utxos = res.map((item: any) => ({
            //utxos = res.body.map((item: any) => ({
            height: -1,
            time: item.time,
            txId: item.txid,
            outputIndex: item.vout,
            satoshis: item.satoshis,
            script: utxoScript,
          }));
        }
        //console.log("UTXO: ", utxos)
      } else {

        bcFinish = false
        //console.log('Not Success: ', resp);

      }

    } catch (e) {
      console.error(e);
    }

    cycle++;
    poolID++;
    poolID = poolID % npools;

    console.log('Pool id: ', poolID)

  }

  console.log('UTXOs: ', utxos)

  if (bcFinish) {
    ///return resp
    return utxos
  }
  else {
    throw new Error('Falha na API ao buscar UTXOs.');
  }
}


//export async function listUnspent(addOrScriptHash: any, homenetwork: any): Promise <string>
export async function listUnspentUnconfWOC(addOrScriptHash: any, homenetwork: any): Promise<UTXO[]> {
  //console.log(`Message received in worker: ${event.data}`);
  //const url = new URL('https://www.example.com/path?query=value');
  let poolID: number = 0; //default = WoC
  let npools: number = 1

  //https://api.whatsonchain.com/v1/bsv/main/address/12XFn6p1H831shGhbd1UobrVqXFEpCBTPp/unspent
  //https://api.bitails.io/address/12XFn6p1H831shGhbd1UobrVqXFEpCBTPp/unspent

  let urlAdress01: string = 'https://api.whatsonchain.com/v1/bsv/main/address/';
  //let urlAdress02: string = 'https://api.bitails.io/address/';

  if (addOrScriptHash.length === 64) {

    console.log('Hash Length: ', addOrScriptHash.length)
    //https://api.whatsonchain.com/v1/bsv/main/script/995ea8d0f752f41cdd99bb9d54cb004709e04c7dc4088bcbbbb9ea5c390a43c3/unspent
    //Returns a response as long as the response message is less than 1MB in size.

    //https://api.bitails.io/scripthash/408d9e88bf59190a2504b0d5e8075fd456c1fe6c593a58177f6df5200e61d118/unspent

    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/main/script/';
    //urlAdress02 = 'https://api.bitails.io/scripthash/';
    //urlAdress03 = 'https://test-api.bitails.io/tx/broadcast';
    //urlAdress04 = 'https://test-api.bitails.io/tx/broadcast/multipart';
  }

  if (homenetwork === bsv.Networks.testnet) {
    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/main/address/';
    //urlAdress02 = 'https://api.bitails.io/address/';

    if (addOrScriptHash.length === 64) {
      //https://api.whatsonchain.com/v1/bsv/main/script/995ea8d0f752f41cdd99bb9d54cb004709e04c7dc4088bcbbbb9ea5c390a43c3/unspent
      //Returns a response as long as the response message is less than 1MB in size.

      //https://api.bitails.io/scripthash/408d9e88bf59190a2504b0d5e8075fd456c1fe6c593a58177f6df5200e61d118/unspent

      urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/main/script/';
      //urlAdress02 = 'https://api.bitails.io/scripthash/';
      //urlAdress03 = 'https://api.bitails.io/tx/broadcast';
      //urlAdress04 = 'https://api.bitails.io/tx/broadcast/multipart';
    }
  }

  /////////////////////////////////////////////////
  //JESUS is the LORD!!!
  /////////////////////////////////////////////////

  let url: URL;

  console.log('pool id', poolID)

  let resp = '';

  let bcFinish = false
  let cycle = 0

  let utxoScript = ''
  if (addOrScriptHash.length !== 64) {
    utxoScript = bsv.Script.buildPublicKeyHashOut(addOrScriptHash).toHex()
  }

  let utxos;
  while (!bcFinish && cycle < npools * 2) {

    //url = new URL(urlAdress01 + addOrScriptHash + '/unspent');
    url = new URL(urlAdress01 + addOrScriptHash + '/unconfirmed/unspent');
    /*
    switch(poolID)
    {
      case 0: url = new URL(urlAdress01 + addOrScriptHash + '/unspent');
              //TXJson = `{"txhex": "${TxHexBsv}" }`; 
        break;
      default: url = new URL(urlAdress02 + addOrScriptHash + '/unspent');
              //TXJson = `{"rawTx": "${TxHexBsv}" }`;
        break;
    }
    */

    console.log('URL', url)

    try {

      console.log('URL', url)

      try {
        const response = await fetch(url);
        resp = await response.text();
      } catch (error) {
        resp = '';
      }

      if (resp.indexOf('[]') !== -1 || resp.indexOf('"time":') !== -1 || resp.indexOf('"height":') !== -1) {

        //console.log('Success: ', resp);
        bcFinish = true

        let res = JSON.parse(resp);

        if (resp.indexOf('[]') !== -1) {
          let res = JSON.parse('[{"height":-2,"tx_pos":-1,"tx_hash":"","value":0}]');
          utxos = res.map((item: any) => ({
            height: item.height,
            time: -2,
            txId: item.tx_hash,
            outputIndex: item.tx_pos,
            satoshis: item.value,
            script: utxoScript,
          }));

        }
        else if (poolID === 0) {
          res = JSON.parse(resp.substring(resp.indexOf('['), resp.indexOf(']') + 1)); //Nova WoC
          //utxos = res.body.map((item: any) => ({
          utxos = res.map((item: any) => ({
            height: 0,
            time: -1,
            txId: item.tx_hash,
            outputIndex: item.tx_pos,
            satoshis: item.value,
            script: utxoScript,
          }));
        }
        else {
          res = JSON.parse(resp.substring(resp.indexOf('['), resp.indexOf(']') + 1));
          utxos = res.map((item: any) => ({
            //utxos = res.body.map((item: any) => ({
            height: -1,
            time: item.time,
            txId: item.txid,
            outputIndex: item.vout,
            satoshis: item.satoshis,
            script: utxoScript,
          }));
        }
        //console.log("UTXO: ", utxos)
      } else {

        bcFinish = false
        //console.log('Not Success: ', resp);

      }

    } catch (e) {
      console.error(e);
    }

    cycle++;
    poolID++;
    poolID = poolID % npools;

    console.log('Pool id: ', poolID)

  }

  if (bcFinish) {
    ///return resp
    return utxos
  }
  else {
    throw new Error('Falha na API ao buscar UTXOs.');
  }
}


//export async function listUnspent(addOrScriptHash: any, homenetwork: any): Promise <string>
export async function listUnspentConfWOC(addOrScriptHash: any, homenetwork: any): Promise<UTXO[]> {
  //console.log(`Message received in worker: ${event.data}`);
  //const url = new URL('https://www.example.com/path?query=value');
  let poolID: number = 0; //default = WoC
  let npools: number = 1

  //https://api.whatsonchain.com/v1/bsv/main/address/12XFn6p1H831shGhbd1UobrVqXFEpCBTPp/unspent
  //https://api.bitails.io/address/12XFn6p1H831shGhbd1UobrVqXFEpCBTPp/unspent

  let urlAdress01: string = 'https://api.whatsonchain.com/v1/bsv/main/address/';
  //let urlAdress02: string = 'https://api.bitails.io/address/';

  if (addOrScriptHash.length === 64) {

    console.log('Hash Length: ', addOrScriptHash.length)
    //https://api.whatsonchain.com/v1/bsv/main/script/995ea8d0f752f41cdd99bb9d54cb004709e04c7dc4088bcbbbb9ea5c390a43c3/unspent
    //Returns a response as long as the response message is less than 1MB in size.

    //https://api.bitails.io/scripthash/408d9e88bf59190a2504b0d5e8075fd456c1fe6c593a58177f6df5200e61d118/unspent

    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/main/script/';
    //urlAdress02 = 'https://api.bitails.io/scripthash/';
    //urlAdress03 = 'https://test-api.bitails.io/tx/broadcast';
    //urlAdress04 = 'https://test-api.bitails.io/tx/broadcast/multipart';
  }

  if (homenetwork === bsv.Networks.testnet) {
    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/main/address/';
    //urlAdress02 = 'https://api.bitails.io/address/';

    if (addOrScriptHash.length === 64) {
      //https://api.whatsonchain.com/v1/bsv/main/script/995ea8d0f752f41cdd99bb9d54cb004709e04c7dc4088bcbbbb9ea5c390a43c3/unspent
      //Returns a response as long as the response message is less than 1MB in size.

      //https://api.bitails.io/scripthash/408d9e88bf59190a2504b0d5e8075fd456c1fe6c593a58177f6df5200e61d118/unspent

      urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/main/script/';
      //urlAdress02 = 'https://api.bitails.io/scripthash/';
      //urlAdress03 = 'https://api.bitails.io/tx/broadcast';
      //urlAdress04 = 'https://api.bitails.io/tx/broadcast/multipart';
    }
  }

  /////////////////////////////////////////////////
  //JESUS is the LORD!!!
  /////////////////////////////////////////////////

  let url: URL;

  console.log('pool id', poolID)

  let resp = '';

  let bcFinish = false
  let cycle = 0

  let utxoScript = ''
  if (addOrScriptHash.length !== 64) {
    utxoScript = bsv.Script.buildPublicKeyHashOut(addOrScriptHash).toHex()
  }

  let utxos;
  while (!bcFinish && cycle < npools * 2) {

    //url = new URL(urlAdress01 + addOrScriptHash + '/unspent');
    url = new URL(urlAdress01 + addOrScriptHash + '/confirmed/unspent');
    /*
    switch(poolID)
    {
      case 0: url = new URL(urlAdress01 + addOrScriptHash + '/unspent');
              //TXJson = `{"txhex": "${TxHexBsv}" }`; 
        break;
      default: url = new URL(urlAdress02 + addOrScriptHash + '/unspent');
              //TXJson = `{"rawTx": "${TxHexBsv}" }`;
        break;
    }
    */

    console.log('URL', url)

    try {

      console.log('URL', url)

      try {
        const response = await fetch(url);
        resp = await response.text();
      } catch (error) {
        resp = '';
      }

      if (resp.indexOf('[]') !== -1 || resp.indexOf('"time":') !== -1 || resp.indexOf('"height":') !== -1) {

        //console.log('Success: ', resp);
        bcFinish = true

        let res = JSON.parse(resp);

        if (resp.indexOf('[]') !== -1) {
          let res = JSON.parse('[{"height":-2,"tx_pos":-1,"tx_hash":"","value":0}]');
          utxos = res.map((item: any) => ({
            height: item.height,
            time: -2,
            txId: item.tx_hash,
            outputIndex: item.tx_pos,
            satoshis: item.value,
            script: utxoScript,
          }));

        }
        else if (poolID === 0) {
          res = JSON.parse(resp.substring(resp.indexOf('['), resp.indexOf(']') + 1)); //Nova WoC
          //utxos = res.body.map((item: any) => ({
          utxos = res.map((item: any) => ({
            height: item.height,
            time: -1,
            txId: item.tx_hash,
            outputIndex: item.tx_pos,
            satoshis: item.value,
            script: utxoScript,
          }));
        }
        else {
          res = JSON.parse(resp.substring(resp.indexOf('['), resp.indexOf(']') + 1));
          utxos = res.map((item: any) => ({
            //utxos = res.body.map((item: any) => ({
            height: -1,
            time: item.time,
            txId: item.txid,
            outputIndex: item.vout,
            satoshis: item.satoshis,
            script: utxoScript,
          }));
        }
        //console.log("UTXO: ", utxos)
      } else {

        bcFinish = false
        //console.log('Not Success: ', resp);

      }

    } catch (e) {
      console.error(e);
    }

    cycle++;
    poolID++;
    poolID = poolID % npools;

    console.log('Pool id: ', poolID)

  }

  if (bcFinish) {
    ///return resp
    return utxos
  }
  else {
    throw new Error('Falha na API ao buscar UTXOs.');
  }
}



export async function getTransaction(txid: any, homenetwork: any): Promise<string>
//export async function listUnspent(addOrScriptHash: any, homenetwork: any): Promise <UTXO[]>
{
  //console.log(`Message received in worker: ${event.data}`);
  //const url = new URL('https://www.example.com/path?query=value');
  let poolID: number = 0; //default = 1 Bitails Big TX
  let npools: number = 2

  //https://api.whatsonchain.com/v1/bsv/<network>/tx/<hash>/hex
  let urlAdress01: string = 'https://api.whatsonchain.com/v1/bsv/main/tx/' + txid + '/hex';
  let urlAdress02: string = 'https://api.bitails.io/download/tx/' + txid;

  if (homenetwork === bsv.Networks.testnet) {
    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/test/tx/' + txid + '/hex';
    urlAdress02 = 'https://test-api.bitails.io/download/tx/' + txid;
  }

  /////////////////////////////////////////////////
  //JESUS is the LORD!!!
  /////////////////////////////////////////////////

  let url: URL;

  console.log('pool id', poolID)

  let resp = '';

  let bcFinish = false
  let cycle = 0


  while (!bcFinish && cycle < npools * 2) {
    switch (poolID) {
      case 0: url = new URL(urlAdress01);
        //TXJson = `{"txhex": "${TxHexBsv}" }`; 
        break;
      default: url = new URL(urlAdress02);
        //TXJson = `{"rawTx": "${TxHexBsv}" }`;
        break;
    }

    console.log('URL ABCDEF', url)

    try {

      console.log('URL', url)


      if (poolID === 1) {
        try {
          const response = await fetch(url);
          const data = await response.arrayBuffer();
          const view = new DataView(data);
          let dataHEX: number[] = [data.byteLength];

          for (let i = 0; i < data.byteLength; i++) {
            dataHEX[i] = view.getUint8(i);
          }
          resp = dataHEX.map(byte => byte.toString(16).padStart(2, '0')).join('');
          console.log('BITAILS TX: ', resp)
        } catch (error) {
          resp = '';
        }
      }
      else {
        try {
          const response = await fetch(url);
          resp = await response.text();
        } catch (error) {
          resp = '';
        }
      }
      //postMessage(dataHEX);

      if (resp.length > 0) {

        //console.log('Success: ', resp);
        bcFinish = true
      }

    } catch (e) {
      console.error(e);
    }

    cycle++;
    poolID++;
    poolID = poolID % npools;

    console.log('Pool id: ', poolID)

  }

  if (bcFinish) {
    return resp
    //return utxos
  }
  else {
    return ''
    //return utxos
  }
}

export interface STXO {
  txId: string;
  inputIndex: number;
}

//export async function getSpentOutput(txid: any, vout: number, homenetwork: any): Promise <string>
export async function getSpentOutput(txid: any, vout: number, homenetwork: any): Promise<STXO[]>
//export async function listUnspent(addOrScriptHash: any, homenetwork: any): Promise <UTXO[]>
{
  //console.log(`Message received in worker: ${event.data}`);
  //const url = new URL('https://www.example.com/path?query=value');
  let poolID: number = 0; //default = 1 Bitails Big TX
  let npools: number = 1

  let position = vout.toString()

  //let stxo: STXO [];
  let stxo: STXO[] = [];


  //https://api.whatsonchain.com/v1/bsv/<network>/tx/<hash>/hex
  let urlAdress01: string = 'https://api.whatsonchain.com/v1/bsv/main/tx/' + txid + '/' + position + '/spent';
  //let urlAdress02: string = 'https://api.bitails.io/download/tx/' + txid;

  if (homenetwork === bsv.Networks.testnet) {
    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/test/tx/' + txid + '/' + position + '/spent';
    //urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/test/tx/' + txid + '/hex';
    //urlAdress02 = 'https://test-api.bitails.io/download/tx/' + txid;
  }

  /////////////////////////////////////////////////
  //JESUS is the LORD!!!
  /////////////////////////////////////////////////

  let url: URL;

  console.log('pool id', poolID)

  let resp = '';

  let bcFinish = false
  let cycle = 0


  while (!bcFinish && cycle < npools * 2) {
    switch (poolID) {
      default: url = new URL(urlAdress01);
        //TXJson = `{"txhex": "${TxHexBsv}" }`; 
        break;
    }

    //console.log('URL ABCDEF', url)

    try {

      console.log('URL', url)

      /////////////////////////////////////////////////
      //JESUS is the LORD!!!
      /////////////////////////////////////////////////
      //Using WoC

      try {
        const response = await fetch(url);
        resp = await response.text();
      } catch (error: any) {
        resp = error.toString();
      }

      //postMessage(dataHEX);

      if (resp.length > 0) {

        //console.log('Success: ', resp);
        bcFinish = true


        if (resp.indexOf('txid') !== -1) {
          let res = JSON.parse('[' + resp + ']');
          stxo = res.map((item: any) => ({
            //utxos = res.body.map((item: any) => ({
            txId: item.txid,
            inputIndex: item.vin,
          }));
        }
        else {
          stxo = [{
            //utxos = res.body.map((item: any) => ({
            txId: '',
            inputIndex: -1,
          }]
        }
        console.log('STXO: ', stxo)

      }

    } catch (e) {
      console.error(e);
    }

    cycle++;
    poolID++;
    poolID = poolID % npools;

    console.log('Pool id: ', poolID)

  }



  if (bcFinish) {
    //return resp
    //return utxos
    return stxo
  }
  else {
    //return ''
    //return utxos
    return stxo
  }

}

export async function getTransactionConf(txid: any, vout: number, homenetwork: any): Promise<boolean> {
  let poolID: number = 0; //default = 1 Bitails Big TX
  let npools: number = 1

  let position = vout.toString()


  //https://api.whatsonchain.com/v1/bsv/<network>/tx/<hash>/hex
  let urlAdress01: string = 'https://api.whatsonchain.com/v1/bsv/main/tx/' + txid + '/' + position + '/spent';
  //let urlAdress02: string = 'https://api.bitails.io/download/tx/' + txid;

  if (homenetwork === bsv.Networks.testnet) {
    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/test/tx/' + txid + '/' + position + '/spent';
    //urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/test/tx/' + txid + '/hex';
    //urlAdress02 = 'https://test-api.bitails.io/download/tx/' + txid;
  }

  /////////////////////////////////////////////////
  //JESUS is the LORD!!!
  /////////////////////////////////////////////////

  let url: URL;

  console.log('pool id', poolID)

  let resp = '';

  let bcFinish = false
  let cycle = 0


  while (!bcFinish && cycle < npools * 2) {
    switch (poolID) {
      default: url = new URL(urlAdress01);
        //TXJson = `{"txhex": "${TxHexBsv}" }`; 
        break;
    }

    //console.log('URL ABCDEF', url)

    try {

      console.log('URL', url)

      /////////////////////////////////////////////////
      //JESUS is the LORD!!!
      /////////////////////////////////////////////////
      //Using WoC

      try {
        const response = await fetch(url);
        resp = await response.text();
      } catch (error: any) {
        resp = error.toString();
      }

      //postMessage(dataHEX);

      if (resp.length > 0) {

        //console.log('Success: ', resp);


        if (resp.indexOf('txid') !== -1) {
          bcFinish = true
        }
        else {
          bcFinish = false
        }

      }

    } catch (e) {
      console.error(e);
    }

    cycle++;
    poolID++;
    poolID = poolID % npools;

    console.log('Pool id: ', poolID)

  }



  if (bcFinish) {
    //return resp
    //return utxos
    return true
  }
  else {
    //return ''
    //return utxos
    return false
  }

}

export async function getTransactionHashHex(txid: any, homenetwork: any): Promise<string> {
  let poolID: number = 0; //default = 1 Bitails Big TX
  let npools: number = 1


  //https://api.whatsonchain.com/v1/bsv/<network>/tx/<hash>/hex
  let urlAdress01: string = 'https://api.whatsonchain.com/v1/bsv/main/tx/' + txid + '/hex';

  if (homenetwork === bsv.Networks.testnet) {
    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/test/tx/' + txid + '/hex';
  }

  /////////////////////////////////////////////////
  //JESUS is the LORD!!!
  /////////////////////////////////////////////////

  let url: URL;

  console.log('pool id', poolID)

  let resp = '';

  let bcFinish = false
  let cycle = 0


  while (!bcFinish && cycle < npools * 2) {
    switch (poolID) {
      default: url = new URL(urlAdress01);
        //TXJson = `{"txhex": "${TxHexBsv}" }`; 
        break;
    }

    //console.log('URL ABCDEF', url)

    try {

      console.log('URL', url)

      /////////////////////////////////////////////////
      //JESUS is the LORD!!!
      /////////////////////////////////////////////////
      //Using WoC

      try {
        const response = await fetch(url);
        resp = await response.text();
      } catch (error: any) {
        resp = error.toString();
      }

      //postMessage(dataHEX);

      if (resp.length > 0) {

        //console.log('Success: ', resp);
        bcFinish = true

      }

    } catch (e) {
      console.error(e);
    }

    cycle++;
    poolID++;
    poolID = poolID % npools;

    console.log('Pool id: ', poolID)

  }



  if (bcFinish) {
    //return resp
    //return utxos
    return resp
  }
  else {
    //return ''
    //return utxos
    return ''
  }

}

export async function getTransactionHashJSON(txid: any, homenetwork: any): Promise<any> {
  let poolID: number = 0; //default = 1 Bitails Big TX
  let npools: number = 1


  //https://api.whatsonchain.com/v1/bsv/<network>/tx/<hash>/hex
  let urlAdress01: string = 'https://api.whatsonchain.com/v1/bsv/main/tx/hash/' + txid;

  if (homenetwork === bsv.Networks.testnet) {
    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/test/tx/hash/' + txid;
  }

  /////////////////////////////////////////////////
  //JESUS is the LORD!!!
  /////////////////////////////////////////////////

  let url: URL;

  console.log('pool id', poolID)

  let resp = '';

  let bcFinish = false
  let cycle = 0


  while (!bcFinish && cycle < npools * 2) {
    switch (poolID) {
      default: url = new URL(urlAdress01);
        //TXJson = `{"txhex": "${TxHexBsv}" }`; 
        break;
    }

    //console.log('URL ABCDEF', url)

    try {

      console.log('URL', url)

      /////////////////////////////////////////////////
      //JESUS is the LORD!!!
      /////////////////////////////////////////////////
      //Using WoC

      try {
        const response = await fetch(url);
        resp = await response.text();
      } catch (error: any) {
        resp = error.toString();
      }

      //postMessage(dataHEX);

      if (resp.length > 0) {

        //console.log('Success: ', resp);
        bcFinish = true

      }

    } catch (e) {
      console.error(e);
    }

    cycle++;
    poolID++;
    poolID = poolID % npools;

    console.log('Pool id: ', poolID)

  }



  if (bcFinish) {
    //return resp
    //return utxos
    return JSON.parse(resp)
  }
  else {
    //return ''
    //return utxos
    return ''
  }

}

export async function getTransactionRaw(txid: any, homenetwork: any): Promise<any> {
  let poolID: number = 0; //default = 1 Bitails Big TX
  let npools: number = 1


  //https://api.whatsonchain.com/v1/bsv/main/tx/2e12e12817d29bb6d790d540f353a25d7426a8d6263544c979805b533e46e8c7/raw
  let urlAdress01: string = 'https://api.whatsonchain.com/v1/bsv/main/tx/' + txid + '/raw';

  if (homenetwork === bsv.Networks.testnet) {
    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/test/tx/' + txid + '/raw';
  }

  /////////////////////////////////////////////////
  //JESUS is the LORD!!!
  /////////////////////////////////////////////////

  let url: URL;

  console.log('pool id', poolID)

  let resp = '';

  let bcFinish = false
  let cycle = 0


  while (!bcFinish && cycle < npools * 2) {
    switch (poolID) {
      default: url = new URL(urlAdress01);
        //TXJson = `{"txhex": "${TxHexBsv}" }`; 
        break;
    }

    //console.log('URL ABCDEF', url)

    try {

      console.log('URL', url)

      /////////////////////////////////////////////////
      //JESUS is the LORD!!!
      /////////////////////////////////////////////////
      //Using WoC

      try {
        const response = await fetch(url);
        resp = await response.text();
      } catch (error: any) {
        resp = error.toString();
      }

      //postMessage(dataHEX);

      if (resp.length > 0) {

        //console.log('Success: ', resp);
        bcFinish = true

      }

    } catch (e) {
      console.error(e);
    }

    cycle++;
    poolID++;
    poolID = poolID % npools;

    console.log('Pool id: ', poolID)

  }



  if (bcFinish) {
    //return resp
    //return utxos
    return resp
  }
  else {
    //return ''
    //return utxos
    return ''
  }

}

export async function getTransactionJSON(txid: any, homenetwork: any): Promise<any> {
  let poolID: number = 0; //default = 1 Bitails Big TX
  let npools: number = 1


  //https://api.whatsonchain.com/v1/bsv/main/tx/hash/2e12e12817d29bb6d790d540f353a25d7426a8d6263544c979805b533e46e8c7
  let urlAdress01: string = 'https://api.whatsonchain.com/v1/bsv/main/tx/hash/' + txid;

  if (homenetwork === bsv.Networks.testnet) {
    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/test/tx/hash/' + txid;
  }

  /////////////////////////////////////////////////
  //JESUS is the LORD!!!
  /////////////////////////////////////////////////

  let url: URL;

  console.log('pool id', poolID)

  let resp = '';

  let bcFinish = false
  let cycle = 0


  while (!bcFinish && cycle < npools * 2) {
    switch (poolID) {
      default: url = new URL(urlAdress01);
        //TXJson = `{"txhex": "${TxHexBsv}" }`; 
        break;
    }

    //console.log('URL ABCDEF', url)

    try {

      console.log('URL', url)

      /////////////////////////////////////////////////
      //JESUS is the LORD!!!
      /////////////////////////////////////////////////
      //Using WoC

      try {
        const response = await fetch(url);
        resp = await response.text();
      } catch (error: any) {
        resp = error.toString();
      }

      //postMessage(dataHEX);

      if (resp.length > 0) {

        //console.log('Success: ', resp);
        bcFinish = true

      }

    } catch (e) {
      console.error(e);
    }

    cycle++;
    poolID++;
    poolID = poolID % npools;

    console.log('Pool id: ', poolID)

  }



  if (bcFinish) {
    //return resp
    //return utxos
    return JSON.parse(resp)
  }
  else {
    //return ''
    //return utxos
    return ''
  }

}

//////////////////////////////////////////////////////////////////////////////////////////
// Jesus is the Lord
//////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////
// OBS: Usando novo modelo de API WOC, completar com Bitails
//////////////////////////////////////////////////////////////////////////////////////////

export async function scriptHistory(addOrScriptHash: any, homenetwork: any): Promise<UTXO[]> {
  let poolID: number = 0; //default = WoC
  let npools: number = 2

  let urlAdress01: string = 'https://api.whatsonchain.com/v1/bsv/main/script/';
  let urlAdress02: string = 'https://api.bitails.io/scripthash/';

  if (homenetwork === 'test') {
    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/test/script/';
    urlAdress02 = 'https://test-api.bitails.io/scripthash/';
  }

  let url: URL;
  let resp = '';
  let bcFinish = false
  let cycle = 0
  let utxos: UTXO[] = [];

  while (!bcFinish && cycle < npools * 2) {
    switch (poolID) {
      case 0: url = new URL(urlAdress01 + addOrScriptHash + '/confirmed/history');
        break;
      default: url = new URL(urlAdress02 + addOrScriptHash + '/unspent');
        break;
    }

    try {
      try {
        const response = await fetch(url);
        resp = await response.text();
      } catch (error) {
        resp = '';
      }

      if (resp.indexOf('Not Found') !== -1 || resp.indexOf('"time":') !== -1 || resp.indexOf('"height":') !== -1) {
        bcFinish = true

        if (resp.indexOf('Not Found') !== -1) {
          let res = JSON.parse('[{"tx_hash":"","height":-2}]');
          utxos = res.map((item: any) => ({
            height: item.height,
            txId: item.tx_hash,
          }));
        } else {
          let index0 = resp.indexOf('"result":[')
          let jsonSTR = resp.substring(index0 + 9, resp.length)
          jsonSTR = jsonSTR.substring(0, jsonSTR.indexOf(']') + 1)
          let res = JSON.parse(jsonSTR);
          utxos = res.map((item: any) => ({
            height: item.height,
            txId: item.tx_hash,
          }));
        }
      } else {
        bcFinish = false
        let res = JSON.parse('[{"tx_hash":"","height":-2}]');
        utxos = res.map((item: any) => ({
          height: item.height,
          txId: item.tx_hash,
        }));
      }
    } catch (e) {
      console.error(e);
    }
    cycle++;
    poolID++;
    poolID = poolID % npools;
  }

  return utxos;
}

export async function scriptHistoryUnc(addOrScriptHash: any, homenetwork: any): Promise<UTXO[]> {
  let poolID: number = 0; //default = WoC
  let npools: number = 1 // somente WoC por enquanto

  let urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/main/script/';
  let urlAdress02 = 'https://api.bitails.io/scripthash/';

  if (homenetwork === bsv.Networks.testnet) {
    urlAdress01 = 'https://api.whatsonchain.com/v1/bsv/test/script/';
    urlAdress02 = 'https://test-api.bitails.io/scripthash/';
  }

  let url: URL;
  let resp = '';
  let bcFinish = false
  let cycle = 0
  let utxos: UTXO[] = [];

  while (!bcFinish && cycle < npools * 2) {
    switch (poolID) {
      case 0: url = new URL(urlAdress01 + addOrScriptHash + '/unconfirmed/history');
        break;
      default: url = new URL(urlAdress02 + addOrScriptHash + '/unspent');
        break;
    }

    try {
      try {
        const response = await fetch(url);
        resp = await response.text();
      } catch (error) {
        resp = '';
      }

      if (resp.indexOf('[]') === -1) {
        bcFinish = true
        if (resp.indexOf('Not Found') !== -1) {
          let res = JSON.parse('[{"tx_hash":"","height":-2}]');
          utxos = res.map((item: any) => ({
            height: item.height,
            txId: item.tx_hash,
          }));
        } else {
          let index0 = resp.indexOf('"result":[')
          let jsonSTR = resp.substring(index0 + 9, resp.length)
          jsonSTR = jsonSTR.substring(0, jsonSTR.indexOf(']') + 1)
          let res = JSON.parse(jsonSTR);
          utxos = res.map((item: any) => ({
            height: item.height,
            txId: item.tx_hash,
          }));
        }
      } else {
        bcFinish = false
        let res = JSON.parse('[{"tx_hash":"","height":-2}]');
        utxos = res.map((item: any) => ({
          height: item.height,
          txId: item.tx_hash,
        }));
      }
    } catch (e) {
      console.error(e);
    }
    cycle++;
    poolID++;
    poolID = poolID % npools;
  }

  return utxos;
}

interface exchagePRICE {
  rate: number,
  time: number,
  currecy: string,
}

export async function exchangeRate(): Promise<exchagePRICE[]> {
  let npools: number = 1 // somente WoC por enquanto
  let url: URL;
  let resp = '';
  let bcFinish = false
  let cycle = 0
  let exchangePrice: exchagePRICE[] = [];

  while (!bcFinish && cycle < npools * 2) {
    url = new URL('https://api.whatsonchain.com/v1/bsv/main/exchangerate')
    try {
      try {
        const response = await fetch(url);
        resp = await response.text();
      } catch (error) {
        resp = '';
      }

      if (resp.indexOf('Not Found') !== -1 || resp.indexOf('"time":') !== -1 || resp.indexOf('"rate":') !== -1) {
        bcFinish = true
        if (resp.indexOf('Not Found') !== -1) {
          let res = JSON.parse('[{"rate":0,"time":0,"currency":"USD"}]');
          exchangePrice = res.map((item: any) => ({
            rate: item.rate,
            time: item.time,
            currecy: item.currency,
          }));
        } else {
          let res = JSON.parse('[' + resp + ']');
          exchangePrice = res.map((item: any) => ({
            rate: item.rate,
            time: item.time,
            currecy: item.currency,
          }));
        }
      }
    } catch (e) {
      console.error(e);
    }
    cycle++;
  }
  return exchangePrice;
}

//////////////////////////////////////////////////////////////////////////////////////////
// Jesus is the Lord
//////////////////////////////////////////////////////////////////////////////////////////

function hexToUint8Array(hexString: string) {
  if (hexString.length % 2 !== 0) {
    throw new Error("Invalid hex string");
  }
  const arrayBuffer = new Uint8Array(hexString.length / 2);
  for (let i = 0; i < hexString.length; i += 2) {
    arrayBuffer[i / 2] = parseInt(hexString.substr(i, 2), 16);
  }
  return arrayBuffer;
}

export async function broadcastArpt(data: any, cypher: string, typeFile: string, endpoint: number, txid: string): Promise<string> {
  let npools: number = 1
  let dataHex = "";

  if (/^[0-9a-fA-F]+$/.test(data) && data.length % 2 === 0) {
    dataHex = data;
  }

  let urlAdress00: string = 'http://147.93.15.76:3005/v1/token/' + data + "/" + cypher;
  let urlAdress01: string = 'http://147.93.15.76:3005/v1/tokenjson/' + cypher;
  let urlAdress02: string = 'http://147.93.15.76:3005/v1/tokenbin/' + cypher + "/" + typeFile;
  let urlAdress03: string = 'http://147.93.15.76:3005/v1/tokenupdate/' + txid + "/" + cypher + "/" + typeFile;

  const binaryData = hexToUint8Array(dataHex);
  let url: URL;
  let bcFinish = false
  let cycle = 0
  let resp = '';

  while (!bcFinish && cycle < npools * 2) {
    try {
      switch (endpoint) {
        case 0: url = new URL(urlAdress00);
          try {
            const response = await fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'accept': 'text/plain' }
            });
            resp = await response.text();
          } catch (error) { resp = ''; }
          break;
        case 1: url = new URL(urlAdress01);
          let TXJson = `{"strData": "${data}" }`;
          try {
            const response = await fetch(url, {
              method: 'POST',
              body: TXJson,
              headers: { 'Content-Type': 'application/json', 'accept': 'text/plain' }
            });
            resp = await response.text();
          } catch (error) { resp = ''; }
          break;
        case 2: url = new URL(urlAdress02);
          try {
            const formData = new FormData();
            formData.append('file', new Blob([binaryData], { type: 'application/octet-stream' }));
            const response = await fetch(url, {
              method: 'POST',
              body: formData,
              headers: { 'accept': 'text/plain' }
            });
            resp = await response.text();
          } catch (error) { resp = ''; }
          break;
        case 3: url = new URL(urlAdress03);
          try {
            const formData = new FormData();
            formData.append('file', new Blob([binaryData], { type: 'application/octet-stream' }));
            const response = await fetch(url, {
              method: 'POST',
              body: formData,
              headers: { 'accept': 'text/plain' }
            });
            resp = await response.text();
          } catch (error) { resp = ''; }
          break;
      }
      if (resp.indexOf("/tx/") !== -1) {
        bcFinish = true
      } else {
        bcFinish = false
      }
    } catch (e) {
      console.error(e);
    }
    cycle++;
  }

  if (bcFinish) {
    return resp.substring(resp.indexOf("/tx/") + 4, resp.indexOf("/tx/") + 4 + 64)
  } else {
    return ''
  }
}

export async function getTokenARPT(txid: any, homenetwork: any, type: number): Promise<string> {
  let poolID: number = 0;
  let npools: number = 2

  let urlAdress00: string = 'http://147.93.15.76:3005/v1/tokenhex/' + txid
  let urlAdress01: string = 'http://147.93.15.76:3005/v1/tokenbin/' + txid
  let urlAdress02: string = 'http://147.93.15.76:3005/v1/tokenfile/' + txid + '/none'
  let urlAdress03: string = 'http://147.93.15.76:3005/v1/tokenfile/' + txid + '/decrypt'

  let url: URL;
  let resp = '';
  let bcFinish = false
  let cycle = 0

  while (!bcFinish && cycle < npools * 2) {
    switch (type) {
      case 1: url = new URL(urlAdress01); break;
      case 2: url = new URL(urlAdress02); break;
      case 3: url = new URL(urlAdress03); break;
      default: url = new URL(urlAdress00); break;
    }

    try {
      if (type === 3 || type === 2) {
        try {
          const response = await fetch(url);
          const contentDisposition = response.headers.get('Content-Disposition');
          const data = await response.arrayBuffer();
          const view = new DataView(data);
          const dataHEX: number[] = [];
          for (let i = 0; i < data.byteLength; i++) {
            dataHEX[i] = view.getUint8(i);
          }
          const decoder = new TextDecoder();
          if (contentDisposition && contentDisposition.indexOf("txt") !== -1) {
            resp = decoder.decode(data);
          } else {
            const hexOriginal = dataHEX.map(byte => byte.toString(16).padStart(2, '0')).join('');
            try {
              const text = new TextDecoder("utf-8", { fatal: true }).decode(data);
              JSON.parse(text);
              resp = text;
            } catch (e) {
              resp = hexOriginal;
            }
          }
          if (contentDisposition) {
            const firstIndex = contentDisposition.indexOf("\"");
            let fileName = contentDisposition.substring(firstIndex + 1);
            fileName = fileName.substring(0, fileName.indexOf("\""));
            resp = fileName + ":" + resp;
          }
        } catch (error) { resp = ''; }
      } else if (type === 1) {
        try {
          const response = await fetch(url);
          const data = await response.arrayBuffer();
          const view = new DataView(data);
          const dataHEX: number[] = [];
          for (let i = 0; i < data.byteLength; i++) {
            dataHEX[i] = view.getUint8(i);
          }
          const hexOriginal = dataHEX.map(byte => byte.toString(16).padStart(2, '0')).join('');
          try {
            const text = new TextDecoder("utf-8", { fatal: true }).decode(data);
            JSON.parse(text);
            resp = text;
          } catch (e) {
            resp = hexOriginal;
          }
        } catch (error) { resp = ''; }
      } else {
        try {
          const response = await fetch(url);
          resp = await response.text();
        } catch (error) { resp = ''; }
      }

      if (resp.length > 0) {
        bcFinish = true
      }
    } catch (e) {
      console.error(e);
    }
    cycle++;
    poolID++;
    poolID = poolID % npools;
  }

  return bcFinish ? resp : '';
}